module.exports = __webpack_public_path__ + "static/media/maf-24.1c601650.png";